<template>
    <div>
        <div class="vertical-polls col-1" id="vertical-surveys" :style="{'height': window.height + 'px' }" v-if="openSwipe">
            <v-row class="vertical-polls-container">
                <v-col cols="12" v-for="(item, i) in questions" :key="i+1"
                       @click="setQuestion(i)">
                    <div style="float: left; width: 28px; max-width: 28px; line-height: 1em;">
                        <span class="question-mobile"><v-icon>ico-b-s-{{ i + 1 }}</v-icon></span>
                    </div>
                    <div style="float: left">
                        <div class="active-mobile" v-if="answeredContainerMobile(i+1) !== null">
                            <span>
                            <v-icon style="font-size: 0 !important;">{{ getLetters(answeredContainerMobile(i+1)) }}</v-icon></span>
                        </div>
                        <div class="inactive-mobile" v-else>
                            <span class="mt-2">-</span>
                        </div>
                    </div>
                </v-col>
            </v-row>
        </div>
        <v-btn  class="open-swipe"
                :class="openSwipe ? 'open-btn' : 'close-btn'"
                @click="swipe()"
                icon>
            <v-icon v-if="openSwipe" color="black" class="icon-open-close">mdi-chevron-right</v-icon>
            <v-icon v-else color="white" class="icon-open-close">mdi-chevron-left</v-icon>
        </v-btn>
        <RomaPdfBtnZoom />
        <div class="container-submit-button">
            <v-btn class="btn-done text-center text-capitalize"
                :class="openSurveys ? 'open-surveys-submit' : 'close-surveys-submit'"
                v-if="!getPollDone"
                color="white"
                outlined
                rounded
                @click="donePoll"
                :disabled="disable">
            <span v-if="!disable">Enviar</span>
            <span v-else>Procesando...</span>
            </v-btn>
        </div>

        <v-container class="black container-roma-poll d-none d-sm-flex d-md-none d-flex d-sm-none">
            <v-progress-linear
                    :active="active"
                    :background-opacity="opacity"
                    :bottom="bottom"
                    :buffer-value="buffer"
                    :height="height"
                    :indeterminate="indeterminate"
                    :query="query"
                    :rounded="rounded"
                    :stream="stream"
                    :striped="striped"
                    :top="top"
                    :value="ProgressValue"
                    color="accent"
                    class="progress-bar"
                    multiple="true"
            ></v-progress-linear>
            <v-row no-gutters align="center"
                    justify="center">
                <v-col cols="12" class="mb-3 mt-5 text-center">
                    <span class="title-questions">Pregunta {{ carouselIndex + 1 }}: <span class="pl-2 pb-4">
                        <v-icon style="font-size: 10px;">{{ getLetters(letter) }}</v-icon></span></span>
                </v-col>
                <v-col cols="1" class="pb-4">
                    <v-btn @click="prev()" icon>
                        <v-icon>icon-btn-left</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="9">
                    <v-row no-gutters align="left"
                            justify="left">
                        <v-carousel
                                v-model="carouselIndex"
                                height="60"
                                :show-arrows="false"
                                hide-delimiters>
                            <v-carousel-item  v-for="(item, i) in questions" :key="i+1">
                                <v-col class="d-flex flex-row flex-grow-0 pa-0">
                                    <v-row no-gutters>
                                        <v-col v-for="(items, x) in item.alternativesNumber" :key="x"
                                                class="flex-grow-0 text-center"
                                                :class="widthOption(item.alternativesNumber)"
                                        >
                                            <button
                                                    :class="answeredOption(i+1, getPosition(x))"
                                                    @click="e => answer(e, i+1, getPosition(x))"
                                                    class="answer">
                                                <v-icon class="icon-letter">{{ getLetter(x) }}</v-icon>
                                            </button>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-carousel-item>
                        </v-carousel>
                    </v-row>
                </v-col>
                <v-col cols="1" class="pb-4">
                    <v-btn @click="next()" icon>
                        <v-icon>icon-btn-right</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import RomaPdfBtnZoom from "../commons/pdf/RomaPdfBtnZoom";
    export default {
        name: "RomaHorizontalPoll",
        data() {
            return {
                model: 0,
                absolute: true,
                active: true,
                opacity: 0,
                bottom: false,
                buffer: 100,
                fixed: false,
                height: 5,
                indeterminate: false,
                query: false,
                rounded: true,
                stream: false,
                striped: false,
                top: false,
                ProgressValue: 0,
                isDone: false,
                changeOption: false,
                disable: false,
                letter: null,
                window: {
                    width: 0,
                    height: 0
                },
                openSwipe: false,
                firstLoaded: false
            }
        },
        components: {
            RomaPdfBtnZoom
        },
        mounted() {
            this.ProgressValue = (100 * this.questionsAnswered.length) / this.totalQuestion;
            this.setOpenSurveys({openSurveys: false});
            this.setLetter();
        },
        created() {
            window.addEventListener("resize", this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener("resize", this.handleResize);
        },
        computed: {
            ...mapGetters({
                totalQuestion: "getquantityQuestions",
                questionAndAnswered: "getQuestionsAndAnswered",
                questionsAnswered: "getQuestionsAnswered",
                questions: "getQuestions",
                idMedicionAsignada: "getMA",
                getPollDone: "getPollDone",
                openSurveys: "getOpenSurveys",
                carouselIndex: "getCarouselIndex",
                getUserData: "getUserData",
                getPolls: "getPolls"
            })
        },
        methods: {
            ...mapActions({
                toastSuccess: "toastSuccess",
                toastError: "toastError",
                setQuestionAndAnswered: "setQuestionAndAnswered",
                setQuestionsAnswered: "setQuestionsAnswered",
                setPollDone: "setPollDone",
                sendPoll: "sendPoll",
                setOpenSurveys: "setOpenSurveys",
                setCarouselIndex: "setCarouselIndex"
            }),
            widthOption(qty) {
                let classOption = "";
                if(qty === 5) {
                    classOption = "col-2 ml-1 mr-1"
                }
                else if (qty === 4) {
                    classOption = "col-3"
                }
                else if (qty === 3) {
                    classOption = "col-4"
                }
                else if (qty === 2) {
                    classOption = "col-6"
                }
                else if (qty === 1) {
                    classOption = "col-12"
                }
                return classOption;
            },
            swipe() {
                if(this.openSwipe) {
                    this.setOpenSurveys({openSurveys: false});
                } else {
                    this.setOpenSurveys({openSurveys: true});
                }
                this.openSwipe = !this.openSwipe;
            },
            async donePoll() {
              if(this.questionsAnswered.length < this.totalQuestion) {
                    const reduce = this.totalQuestion - this.questionsAnswered.length;
                    this.toastError({title: "Completar la encuesta", message: `Faltan ${reduce} preguntas por responder` });
                } else {
                    this.disable = true;
                    const answers = {
                    "idMedicionAsignada": this.idMedicionAsignada ,
                    "answerQuestionList": this.questionAndAnswered,
                    "idPersona":  this.getUserData && this.getUserData.personId ? this.getUserData.personId : null,
                        // "idSeccion": this.getPolls[0] && this.getPolls[0].sectionTO.sectionId ? this.getPolls[0].sectionTO.sectionId : null,
                        "idSeccionOrigen": this.getPolls[0] && this.getPolls[0].idSeccionOrigen,
                        "tipoPerfil":this.getPolls[0] && this.getPolls[0].perfil,
                        "userName":this.getUserData && this.getUserData.userName ? this.getUserData.userName : null
                    }
                    
                    await this.sendPoll({answers: answers})
                    .then(response => {
                        if(response.status === 200 || response == "Encuesta ya fue enviada"){
                            console.log('SetPOLLDONE')
                            this.setPollDone({pollDone: true});
                        }
                        if(response.status === 200) {
                            this.disable = false;
                            this.isDone = true;
                        } else {
                            this.disable = false;
                            if(response == "Encuesta ya fue enviada"){
                                this.isDone = true;
                            }else{
                                this.toastError({title: "Error", message: response });
                            }
                        }
                    })
                    
                }
            },
            answer(e, item, option) {
                const question =  this.questionAndAnswered.find(answer => answer.questionNumber === item);
                if(typeof question !== 'undefined') {
                    for(const qn of this.questionAndAnswered) {
                        if(qn.questionNumber === item) {
                            this.letter = null;
                            if(qn.answerLetter === option) {
                                // Remove option
                                this.letter = null;
                                const i = this.questionAndAnswered.map(e => e.questionNumber).indexOf(item);
                                this.questionAndAnswered.splice(i, 1);
                                const op = this.questionsAnswered.indexOf(item);
                                this.questionsAnswered.splice(op, 1 );
                                this.letter = null;
                                if(this.changeOption) {
                                    // Remove and add
                                    this.letter = null;
                                    this.questionsAnswered.push(item);
                                    this.questionAndAnswered.push({"questionNumber" : item,	"answerLetter" : option });
                                    this.letter = option;
                                    this.changeOption = false;
                                    this.openSwipe = true;
                                    this.setOpenSurveys({openSurveys: true});
                                    e.target.classList.toggle('active');
                                }
                            } else {
                                // Change
                                this.letter = null;
                                const i = this.questionAndAnswered.map(e => e.questionNumber).indexOf(item);
                                this.questionAndAnswered.splice(i, 1);
                                const op = this.questionsAnswered.indexOf(item);
                                this.questionsAnswered.splice(op, 1 );
                                this.questionsAnswered.push(item);
                                this.questionAndAnswered.push({"questionNumber" : item,	"answerLetter" : option });
                                this.letter = option;
                                this.openSwipe = true;
                                this.setOpenSurveys({openSurveys: true});
                                e.target.classList.toggle('active');
                                this.changeOption = true;
                            }
                        }
                    }

                } else {
                    // Add
                    this.questionsAnswered.push(item);
                    this.questionAndAnswered.push({"questionNumber" : item,	"answerLetter" : option });
                    this.letter = option;
                    e.target.classList.toggle('active');
                    if (!this.firstLoaded) {
                        this.openSwipe = true;
                        this.setOpenSurveys({openSurveys: true});
                    }
                }
                this.ProgressValue = (100 * this.questionsAnswered.length) / this.totalQuestion;
                this.setQuestionsAnswered({questionsAnswered: this.questionsAnswered })
                this.setQuestionAndAnswered({questionAndAnswered: this.questionAndAnswered })
            },
            answeredContainer(id) {
                const question =  this.questionsAnswered.find(answer => answer === id);
                return [id === question ? 'answered' : ''];
            },
            answeredContainerMobile(id) {
                const question  =  this.questionAndAnswered.find(answer =>  answer.questionNumber === id);
                const option    = typeof question !== 'undefined' ? question.answerLetter : null;
                console.log(option)
                return option;
            },
            answeredBtn(id) {
                const question =  this.questionsAnswered.find(answer => answer === id);
                return [id === question ? 'btn-answered' : ''];
            },

            answeredOption(id, option) {
                const question =  this.questionAndAnswered.find(answer => answer.answerLetter === option && answer.questionNumber === id);
                const op = typeof question !== 'undefined' ? question.answerLetter : null;
                return [option === op ? 'active' : 'answer'];
            },

            getPosition(x) {
                const array = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L'];
                return array[x];
            },
            next() {
                const i = this.carouselIndex;
                const index = i + 1;
                if(index <= this.questions.length - 1){
                    this.setCarouselIndex({ carouselIndex:  index });
                } else {
                    this.setCarouselIndex({ carouselIndex:  0 });
                }
                this.setLetter();
                this.openSwipe = false;
                this.setOpenSurveys({openSurveys: false});
            },
            prev() {
                const i = this.carouselIndex;
                const index = i - 1;
                if(index >= 0) {
                    if(index === 0) {
                        this.setCarouselIndex({ carouselIndex:  0 });
                    }  else {
                        this.setCarouselIndex({ carouselIndex:  index });
                    }

                } else {
                    this.setCarouselIndex({ carouselIndex: this.questions.length - 1})
                }
                this.setLetter();
                this.openSwipe = false;
                this.setOpenSurveys({openSurveys: false});
            },
            setLetter() {
                if(this.carouselIndex >= 0) {
                    const question =  this.questionAndAnswered.find(answer => answer.questionNumber === this.carouselIndex + 1);
                    this.letter = typeof question !== 'undefined' ?  question.answerLetter : null;
                }
            },
            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            setQuestion(q) {
                this.letter = this.answeredContainerMobile(q+1);
                this.setCarouselIndex({ carouselIndex: q})
            },
            getLetter(x) {
                let letter = null;
                if(x === 0) {
                    letter = "letter-white-a";
                }
                else if (x === 1) {
                    letter = "letter-white-b";
                }
                else if (x === 2) {
                    letter = "letter-white-c";
                }
                else if (x === 3) {
                    letter = "letter-white-d";
                }
                else if (x === 4) {
                    letter = "letter-white-e";
                }
                else if (x === 5) {
                    letter = "letter-white-e";
                }
                return letter;
            },
            getLetters(l) {
                let letter = null;
                if(l === 'A') {
                    letter = "letter-white-a";
                }
                else if (l === 'B') {
                    letter = "letter-white-b";
                }
                else if (l === 'C') {
                    letter = "letter-white-c";
                }
                else if (l === 'D') {
                    letter = "letter-white-d";
                }
                else if (l === 'E') {
                    letter = "letter-white-e";
                }
                return letter;
            }

        }
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/styles/numbers.css";

    .container-submit-button{
        width: 100%;
        position: fixed;
        bottom: 185px;
        z-index: 5000;
    }

    .open-surveys-submit{
        right: 75px;
    }

    .container-roma-poll {
        position: fixed;
        bottom: 0;
        padding: 0 25px 12px 25px !important;
        z-index: 50;
        right: 0;
        .answer {
            background: #3a8fce;
            border-radius: 5px;
            opacity: 1;
            border: none;
            flex-grow: 0;
            margin-bottom: 15px;
            color: #ffffff;
        }

        .center {
            margin: 0;
            position: relative;
            top: 50%;
            left: 50%;
            transform: translate(-40%, -65%);
        }

        .center-button {
            position: absolute;
            left: 50%;
            bottom: -30%;
        }

        .active {
            background: #f39444 0 0 no-repeat padding-box;
            color: #ffffff !important;
        }

        .title-questions {
            color: #ffffff;
            font-size: 14px;
            margin-bottom: 15px;
        }

        .blue {
            background: #3a8fce;
            color: #ffffff;
        }

        .arrow {
            width: 20px !important;
            max-width: 20px;
            min-width: 20px !important;
        }

        .progress-bar {
            position: absolute;
            left: 0;
            width: 100%;
        }
        .v-progress-linear__buffer {
            background: #d9d9d9 !important;
        }

        .v-application .accent {
            background-color: #e97c21 !important;
            border-color: #e97c21 !important;
            border-radius: 15px;
            z-index: 2;
        }

        .icon-btn-left::before {
            margin-top: 5px;
            margin-right: 10px;
            margin-left: 5px;
            content: url("../../assets/images/btn-left.png");
        }

        .icon-btn-right::before {
            margin-left: 5px;
            content: url("../../assets/images/btn-rigth.png");
        }
    }

    .done-btn {
        position: absolute;
        top: -10px;
    }

    .open-swipe {
        position: fixed;
        right: -14px;
        z-index: 100;
        top: 37%;
        background: #ffffff;
        opacity: 0.7;
        i {
            color: #ffffff;
        }
    }
    .open-btn {
        background: #ffffff;
    }
    .close-btn {
        background: #000000;
    }

    .icon-open-close {
        padding-right: 12px;
    }

    #vertical-surveys {
        position: fixed;
        top: 56px;
        bottom: 70px;
        width: 105px;
        max-width: 105px;
        background: #000000;
        opacity: 0.8;
        z-index: 30;
        color: #ffffff;
        padding-bottom: 110px;
        margin-bottom: 90px;
        overflow-y: scroll;
        right: -12px;
    }

    .vertical-polls {
        .vertical-polls-container {
            /*overflow-y: scroll;*/
            padding-top: 2px;
            padding-bottom: 150px !important;
        }
        .question-mobile {
            font-size: 10px !important;
            margin-right: 8px;
            margin-left: 6px;
            line-height: 1em;;
        }
        .active-mobile {
            background: #e97c21;
            width: 24px;
            height: 24px;
            border-radius: 3px;
            padding: 0 5px 30px 5px;
            margin-left: 2px;
            text-align: center;
        }
        .inactive-mobile {
            background: transparent;
            width: 24px;
            height: 24px;
            border-radius: 3px;
            padding: 0 5px 30px 5px;
            margin-left: 2px;
            text-align: center;
        }
    }

    .icon-letter {
        padding-bottom: 3px;
        padding-left: 1px;
        background: transparent !important;
    }

    .letter-white-a:before {
        content: url("../../assets/images/letter/a.svg");
    }

    .letter-white-b:before {
        content: url("../../assets/images/letter/b.svg");
    }

    .letter-white-c:before {
        content: url("../../assets/images/letter/c.svg");
    }

    .letter-white-d:before {
        content: url("../../assets/images/letter/d.svg");
    }

    .letter-white-e:before {
        content: url("../../assets/images/letter/e.svg");
    }

    @media(max-width: 500px)  {
        .button-option {
            padding-left: 6%;
        }
    }


</style>